<template lang="html">
    <data-table
        :headers="datatable.headers"
        :endpoint="datatable.endpoint"
        :actions="datatable.actions"
        :views="datatable.views"
        @rowClick="rowClick"
        storeId="symbols"
        ref="list"
    >
        <template slot="items" slot-scope="props">
            <td>
                {{ props.item.label }}
            </td>
            <td class="text-xs-left last-modif">
                <avatar :item="props.item.user" size="4rem"></avatar>
                <span class="highlight-name">{{props.item.user.first_name}} {{props.item.user.last_name}}</span> le {{moment(props.item.updated_at).format('DD/MM/YYYY')}}
            </td>
            <td class="text-xs-center">
                {{props.item.requests.length}}
            </td>
        </template>
    </data-table>
</template>

<script>
import Create from './Create.vue'
import Single from './Single.vue'
import moment from 'moment'
moment.locale('fr')
import DataTable from '../../../components/DataTable'
import Avatar from '../../../components/avatar/Avatar'

export default {
	components: { DataTable, Avatar },

	props: {
		filter: {
			required: false
		}
	},

	data() {
		return {
		    moment,
			datatable: {
				actions: [
					{
                        text: 'Ajouter un nouveau symbole', icon: 'add_circle', callback: () => {
                            this.$eventHub.$emit('open-modal', Create);
                       }, level: 60
                   }
				],
				views: [
					{ text: 'Tous les symboles', link: 'list-symbols' }
				],
				headers: [
					{ text: 'Nom du symbole', sortable: true,   value: 'label', align: 'left', width: '40%' },
					{ text: 'Dernière modification', sortable: true,   value: 'updated_at', align: 'left' },
					{ text: 'Nombre de produits liés', sortable: true,   value: 'label', align: 'center' },
				],
				endpoint: {
					base: '/api/symbols',
					filters: this.setFilters,
					embed: 'user,requests,products,linked_products'
				}
			}
		}
	},

	methods: {
		rowClick(item) {
		    this.$eventHub.$emit('open-modal', Single,{ id: item.id });
		}
	},
	created() {
		this.$eventHub.$on('reload-list', () => {
			if (this.$refs.list) {
				this.$refs.list.reload()
			}
		})

	}
}
</script>

<style lang="stylus" scoped>
    .highlight-name {
        font-weight : 700;
        padding : 0 10px;
    }
    .last-modif{
        min-width: 350px
    }
</style>



// WEBPACK FOOTER //
// src/views/symbols/list/List.vue